<template>
  <div class="container">
    <van-sticky>
      <!-- 顶部 -->
      <div class="top">
        <span :class="BusinessTypeIndex == 1 ? 'active' : ''" @click="changeBusinessTypeIndex(1)">{{
          $t('public').USDTcontract }}</span>
        <!-- <span :class="BusinessTypeIndex == 2 ? 'active' : ''" @click="changeBusinessTypeIndex(2)">{{
          $t('public').Fiatcurrencycontract }}</span> -->
        <span :class="BusinessTypeIndex == 3 ? 'active' : ''" @click="changeBusinessTypeIndex(3)">{{ $t('public').spot
        }}</span>
        <span :class="BusinessTypeIndex == 4 ? 'active' : ''" @click="changeBusinessTypeIndex(4)">{{ $t('public').secondContract
        }}</span>
      </div>
      <!-- 产品数据 -->
      <div class="proNum">
        <div class="left" @click="onShowProduct">
          <div class="name">{{ proInfo.name }}</div>
          <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
          <div class="flu" :class="proInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ proInfo.priceChangeRatio }}%</div>
          <div class="closetime" v-if="proInfo.isCloseTime">{{ $t('trade').CloseTime }}</div>
        </div>
        <svg-icon class-name="svgs" icon-class="kline" @click="$router.push({ name: 'Kline', query: { id: productId } })" />
      </div>
    </van-sticky>
    <!-- 交易 成交 -->
    <div class="conInfo">
      <!-- 交易合约 -->
      <div class="tradeInfo" v-if="BusinessTypeIndex == 1||BusinessTypeIndex == 2">
        <!-- 全仓 杠杆 -->
        <van-popover v-model="showPopover_Lever" placement="bottom-end" :actions="actions_Lever" @select="onSelect_Lever">
          <template #reference>
            <div class="level" @click="showPopover_Lever = !showPopover_Lever">{{ $t('trade').Fullwarehouse }}<span>{{
              Lever }}X <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span></div>
          </template>
        </van-popover>
        <!-- 开仓平仓 -->
        <!-- <div class="tabs">
          <div class="left" :class="buyDirection == '0' ? 'active' : ''" @click="buyDirection = '0'">{{
            $t('trade').buyBtn
          }}
          </div>
          <div class="right" :class="buyDirection == '1' ? 'active' : ''" @click="buyDirection = '1'">{{
            $t('trade').sellBtn
          }}
          </div>
        </div> -->
        <!-- 市价限价 -->
        <van-popover v-model="showPopover_tradeType" placement="bottom-end" :actions="actions_tradeType" @select="onSelect_TradeType">
          <template #reference>
            <div class="trdType" @click="showPopover_tradeType = !showPopover_tradeType">{{ TradeType == '1' ?
              $t('trade').Present : $t('trade').Limit }}<van-icon name="play" size="13" class="ric" color="var(--text_color)" /></div>
          </template>
        </van-popover>
        <!-- 市价 -->
        <div class="lable" v-if="TradeType == '1'">{{ $t('trade').markPriceMsg }}</div>
        <!-- 限价 -->
        <van-field v-model="LimitPrice" type="number" :label="$t('trade').limitMsg" v-if="TradeType == '0'" @input="calMarginAmount">
        </van-field>
        <!-- 数量 -->
        <van-field v-model="Num" type="number" :label="$t('trade').num" @input="onInputNum"></van-field>
        <!-- 选择百分比 -->
        <div class="sliderPrecent">
          <!-- <van-slider v-model="activePrecent" @change="handlePrecent" bar-height="7" button-size="12"
            active-color="var(--text_color)" inactive-color="var(--info_color)">
          </van-slider>
          <div class="slable"><span>0%</span><span>25%</span><span>50%</span><span>75%</span><span>100%</span></div> -->
          <vue-slider v-model="activePrecent" @drag-start="onDragStart" @drag-end="onDragEnd" @change="handlePrecent" :min="0" :max="100" :interval="1" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }" :dot-size="15" :tooltip="'hover'"
            :rail-style="{ backgroundColor: 'var(--info_color)', height: '3px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
            :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
        </div>
        <!-- 止盈止损 -->
        <div class="lable2" @click="isSetStop = !isSetStop"><van-checkbox icon-size="12" v-model="isSetStop" checked-color="var(--text_color)"></van-checkbox><span> {{ $t('trade').zyzsSet }}</span></div>
        <div v-if="isSetStop">
          <!-- 止盈价 -->
          <van-field v-model="StopSurplusPrice" type="number" :label="$t('trade').zyPrice" />
          <!-- 止损价 -->
          <van-field v-model="StopLossPrice" type="number" :label="$t('trade').zsPrice" />
        </div>
        <!-- 可用余额 -->
        <div class="bal">{{ $t('trade').balance }}<span>{{ AssetBalance }} {{ currency }} <svg-icon class-name="svgs" icon-class="add" @click="toRecharge" v-if="!$store.state.isSim" /></span>
        </div>
        <!-- 可开多 -->
        <div class="txt">{{ $t('trade').corkado }}<span class="green">{{ CanNum }}</span></div>
        <!-- 保证金 -->
        <div class="txt">{{ $t('trade').Margin }}<span>{{ Margin }} {{ currency }} </span>
        </div>
        <!-- 开多 -->
        <div class="buyBtn" @click="showOrderInfo(0)">{{ $t('trade').Kato }}</div>
        <!-- 可开空 -->
        <div class="txt">{{ $t('trade').openable }}<span class="red">{{ CanNum }}</span></div>
        <!-- 保证金 -->
        <div class="txt">{{ $t('trade').Margin }}<span>{{ Margin }} {{ currency }} </span>
        </div>
        <!-- 开空 -->
        <div class="sellBtn" @click="showOrderInfo(1)">{{ $t('trade').Openempty }}</div>
      </div>
      <!-- 交易现货 -->
      <div class="tradeInfobb" v-if="BusinessTypeIndex == 3">
        <!-- 买入卖出 -->
        <div class="tabs">
          <div class="left" :class="buyDirection == 0 ? 'active' : ''" @click="onBuyDirection(0)">{{
            $t('trade').buyBtn
          }}
          </div>
          <div class="right" :class="buyDirection == 1 ? 'active1' : ''" @click="onBuyDirection(1)">{{
            $t('trade').sellBtn
          }}
          </div>
        </div>
        <!-- 市价限价 -->
        <van-popover v-model="showPopover_tradeType" placement="bottom-end" :actions="actions_tradeType" @select="onSelect_TradeType">
          <template #reference>
            <div class="trdType" @click="showPopover_tradeType = !showPopover_tradeType">{{ TradeType == '1' ?
              $t('trade').Present : $t('trade').Limit }}<van-icon name="play" size="13" class="ric" color="var(--text_color)" /></div>
          </template>
        </van-popover>
        <!-- 市价 -->
        <div class="lable" v-if="TradeType == '1'">{{ $t('trade').markPriceMsg }}</div>
        <!-- 限价 -->
        <van-field v-model="LimitPrice" type="number" :label="$t('trade').limitMsg" v-if="TradeType == '0'" @input="calMarginAmount">
        </van-field>
        <!-- 数量 -->
        <van-field v-model="Num" type="number" :label="$t('trade').num" @input="onInputNum"></van-field>
        <!-- 选择百分比 -->
        <div class="sliderPrecent">
          <!-- <van-slider v-model="activePrecent" @change="handlePrecent" bar-height="7" button-size="12"
            active-color="var(--text_color)" inactive-color="var(--info_color)">
          </van-slider>
          <div class="slable"><span>0%</span><span>25%</span><span>50%</span><span>75%</span><span>100%</span></div> -->
          <vue-slider v-model="activePrecent" @drag-start="onDragStart" @drag-end="onDragEnd" @change="handlePrecent" :min="0" :max="100" :interval="1" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }" :dot-size="15" :tooltip="'hover'"
            :rail-style="{ backgroundColor: 'var(--info_color)', height: '3px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
            :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
        </div>
        <!-- 金额 -->
        <van-field v-model="Margin" type="number" :label="$t('trade').totalAmount" readonly></van-field>
        <!-- 可用余额 -->
        <div class="bal">{{ $t('trade').balance }}<span>{{ AssetBalance }} {{ currency }} <svg-icon class-name="svgs" icon-class="add" @click="$goRecharge('RechargeCurrency')" v-if="!$store.state.isSim" /></span>
        </div>
        <!-- 可买-->
        <div class="txt" v-if="buyDirection == 0">{{ $t('trade').purchasable }}<span class="red">{{ CanNum }}</span>
        </div>
        <!-- 可卖 -->
        <div class="txt" v-if="buyDirection == 1">{{ $t('trade').vendibility }}<span class="red">{{
          AssetBalance.toFixed(2).replace(/\.?0+$/, '')
        }}</span></div>
        <!-- 买入 -->
        <div class="buyBtn" @click="showOrderInfo_coin(0)" v-if="buyDirection == 0">{{ $t('trade').buyBtn }}</div>
        <!-- 卖出 -->
        <div class="sellBtn" @click="showOrderInfo_coin(1)" v-if="buyDirection == 1">{{ $t('trade').sellBtn }}</div>
      </div>
      <!-- 秒合约 -->
      <div class="tradeInfoSec" v-if="BusinessTypeIndex == 4">
        <!-- 到期时间 -->
        <div class="lable">{{ $t('trade').selectSeconds }}</div>
        <div class="secItems">
          <div class="item" :class="secondYieldInfo.productSecondSetId == dItem.productSecondSetId?'active':''" v-for="(dItem, dIndex) in secondYieldList" :key="`secYield${dIndex}`" @click="secondYieldInfo=dItem">
            <div>{{dItem.yield}}%</div>
            <div class="txtss">{{dItem.second}}s</div>
          </div>
        </div>
        <!-- 金额 -->
        <van-field v-model="Num" type="number" :label="$t('trade').totalAmount" @input="onInputNum"></van-field>
        <!-- 选择百分比 -->
        <div class="sliderPrecent">
          <vue-slider v-model="activePrecent" @drag-start="onDragStart" @drag-end="onDragEnd" @change="handlePrecent" :min="0" :max="100" :interval="1" :marks="{ 0: '0%', 25: '25%', 50: '50%', 75: '75%', 100: '100%' }" :dot-size="15" :tooltip="'hover'"
            :rail-style="{ backgroundColor: 'var(--info_color)', height: '3px' }" :process-style="{ backgroundColor: 'var(--text_color)' }" :dot-style="{ backgroundColor: 'var(--background_color)', border: '2px solid var(--text_color)' }"
            :tooltip-style="{ backgroundColor: 'var(--info_color)', color: 'var(--text_color)', padding: '4px 8px', borderRadius: '4px' }" />
        </div>
        <!-- 最低买入金额 -->
        <div class="bal">{{ $t('trade').minbuyNums }}<span>{{ secondYieldInfo.minNum }} USDT</span>
        </div>
        <!-- 可用余额 -->
        <div class="bal">{{ $t('trade').balance }}<span>{{ AssetBalance }} USDT <svg-icon class-name="svgs" icon-class="add" @click="toRecharge" v-if="!$store.state.isSim" /></span>
        </div>
        <!-- 买涨 -->
        <div class="buyBtn" @click="showOrderInfo_sec(0)">{{ $t('trade').buyUp }}</div>
        <!-- 买跌 -->
        <div class="sellBtn" @click="showOrderInfo_sec(1)">{{ $t('trade').buyDown }}</div>
      </div>
      <!-- 成交 -->
      <div class="orderBook">
        <van-skeleton title :row="15" :loading="skeletonLoading">
          <!-- 标题 数量 价格-->
          <div class="tit"><span>{{ $t('trade').limitMsg }}</span><span>{{ $t('trade').num }}</span></div>
          <!-- 买盘 -->
          <div v-for="(order, index) in buyOrders" :key="'buy-' + index" class="orderRow" :style="isSetStop ? 'padding: 8.5px 0;' : ''">
            <div class="price green">{{ order.newPrice }}</div>
            <div class="quantity">{{ order.vol2 | formatNumber }}</div>
            <div class="buybar" :style="{ width: calculateBarWidth(order.vol2) }"></div>
          </div>
          <!-- 当前价格 -->
          <div class="newprice" :class="proInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ proInfo.newPrice }}</div>
          <!-- 卖盘 -->
          <div v-for="(order, index) in sellOrders" :key="'sell-' + index" class="orderRow" :style="isSetStop ? 'padding: 8.5px 0;' : ''">
            <div class="price red">{{ order.newPrice }}</div>
            <div class="quantity">{{ order.vol2 | formatNumber }}</div>
            <div class="sellbar" :style="{ width: calculateBarWidth(order.vol2) }"></div>
          </div>
        </van-skeleton>
      </div>
    </div>
    <div class="lines"></div>
    <!-- 持仓tab 合约-->
    <div class="positionTitle">
      <div class="left" v-show="BusinessTypeIndex == 1||BusinessTypeIndex == 2">
        <span v-for="(item, index) in tabsOrder" :key="`tabbus${index}`" :class="activeOrder == item.value ? 'active' : ''" @click="changeOrderTab(item.value)">{{ item.name
          }}</span>
      </div>
      <svg-icon class-name="svgs" icon-class="position" @click="$router.push({ name: 'Position' })" />
    </div>
    <!-- 持仓列表 合约-->
    <div class="positionInfo" v-if="BusinessTypeIndex == 1||BusinessTypeIndex == 2">
      <div class="title">
        <!-- 标题 -->
        <span class="direction">{{ $t('trade').direction }}</span>
        <span>{{ $t('trade').Entrustedprice }}</span>
        <span>{{ $t('trade').Entrustednum }}</span>
        <span>{{ $t('position').profitloss }}</span>
        <span class="time">{{ $t('position').Entrustedtime }}</span>
      </div>
      <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`" @click="$router.push({ name: 'PositionInfo', query: { i: dItem.orderId } })">
        <span class="direction" :class="dItem.buyDirection == '0' ? 'green' : 'red'">{{ dItem.buyDirection == '0' ?
          $t('trade').Kato : $t('trade').Openempty }}</span>
        <span>{{ dItem.price }}</span>
        <span>{{ dItem.quantity }}</span>
        <span :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{ dItem.profitAmount }}</span>
        <span class="time">{{ dItem.createTime | getLocalTime }}</span>
      </div>
      <div class="empty" v-if="isEmpty">
        <svg-icon class-name="esvgs" icon-class="empty" />
        <div class="txt">{{ $t('public').emptyTxt }}</div>
      </div>
    </div>
    <!-- 持仓列表 现货-->
    <div class="positionInfo_coin" v-if="BusinessTypeIndex == 3">
      <div class="title">
        <!-- 标题 -->
        <span class="direction">{{ $t('trade').direction }}</span>
        <span>{{ $t('c2c').price }}</span>
        <span>{{ $t('c2c').quantity }}</span>
        <span>{{ $t('c2c').amountmoney }}</span>
        <div class="time">{{ $t('market').time }}</div>
        <div class="stau">{{ $t('position').status }}</div>
      </div>
      <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`" @click="$router.push({ name: 'PositionInfo', query: { i: dItem.orderId } })">
        <span class="direction" :class="dItem.buyDirection == '0' ? 'green' : 'red'">{{ dItem.buyDirection == '0' ?
          $t('trade').buyBtn : $t('trade').sellBtn }}</span>
        <span>{{ dItem.price }}</span>
        <span>{{ dItem.quantity }}</span>
        <span>{{ dItem.amount }}</span>
        <div class="time">{{ dItem.createTime | getLocalTime }}</div>
        <div class="stau" :class="dItem.status == 1 ? 'greenbg' : 'redbg'"> {{ dItem.status == 1 ?
          $t('c2c').inprogress :
          dItem.status == 3 ? $t('c2c').Completed :
            dItem.status == 4 ? $t('c2c').Cancelled : '' }}</div>
      </div>
      <div class="empty" v-if="isEmpty">
        <svg-icon class-name="esvgs" icon-class="empty" />
        <div class="txt">{{ $t('public').emptyTxt }}</div>
      </div>
    </div>
    <!-- 持仓列表 秒合约-->
    <div class="positionInfo" v-if="BusinessTypeIndex == 4">
      <div class="title">
        <!-- 标题 -->
        <span class="direction">{{ $t('trade').direction }}</span>
        <span>{{ $t('trade').Entrustedprice }}</span>
        <span>{{ $t('trade').totalAmount }}</span>
        <span>{{ $t('position').profitloss }}</span>
        <span class="time">{{ $t('position').Entrustedtime }}</span>
      </div>
      <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`" @click="$router.push({ name: 'PositionSecondInfo', query: { i: dItem.orderSecondId } })">
        <span class="direction" :class="dItem.buyDirection == '0' ? 'green' : 'red'">{{ dItem.buyDirection == '0' ?
          $t('trade').buyUp : $t('trade').buyDown }}</span>
        <span>{{ dItem.price }}</span>
        <span>{{ dItem.amount }}</span>
        <span :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{ dItem.profitAmount||'-' }}</span>
        <span class="time">{{ dItem.createTime | getLocalTime }}</span>
      </div>
      <div class="empty" v-if="isEmpty">
        <svg-icon class-name="esvgs" icon-class="empty" />
        <div class="txt">{{ $t('public').emptyTxt }}</div>
      </div>
    </div>
    <!-- 产品列表 -->
    <van-popup v-model="showProList" closeable position="bottom" :style="{ overflow: 'hidden' }" @close="getProductInfo">
      <div class="pro_list">
        <!-- 搜索 -->
        <div class="serarchInfo">
          <!-- 搜索 -->
          <van-search v-model="searchValue" shape="round" background="var(--background_color)" :placeholder="$t('public').search" @search="onSearch" @cancel="onSearch" @clear="onSearch" @input="onSearch" />
        </div>
        <!-- 顶部 -->
        <div class="topInfo">
          <!-- 行情分类 -->
          <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`" :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
              }}</span></div>
          <!-- 产品业务 -->
          <div class="protypeTab">
            <div class="left">
              <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{
                  item.name
                }}</span>
            </div>
            <svg-icon class-name="svgs" icon-class="edit" v-if="activeMarket == 0 && !showAddSelect" @click="$router.push({ name: 'MySelect' })" />
          </div>
          <!-- 产品类型 -->
          <div class="tabs" v-if="(activeBusiness == 2||activeBusiness == 4)  && tabsType.length > 2"><span v-for="(item, index) in tabsType" :key="`tabtype${index}`" :class="activeType == item.value ? 'active' : ''" @click="changeTypeTab(item.value)">{{ item.name
              }}</span>
          </div>
          <!-- 产品标题 -->
          <div class="title">
            <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
              $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span>
          </div>
        </div>
        <!-- 添加自选 -->
        <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
          <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
          }}</van-button>
        </div>
        <!-- 产品列表 -->
        <div class="productInfo" :style="'height: calc(90vh - ' + ((activeBusiness == 2||activeBusiness == 4) && tabsType.length > 2 ? 250 : 210) + 'px);'">
          <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="onGetProductList" :immediate-check="false">
            <div class="item" v-for="(item, index) in pList" :key="`pro${index}`" @click="selectProduct(item.productId)">
              <div class="name"><img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
              <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
              <span>{{ item.volume | formatNumber }}</span>
              <span :class="item.priceChangeRatio > 0 ? 'greenbg' : 'redbg'" class="ratio">{{ item.priceChangeRatio
              }}%</span>
            </div>
          </van-list>
        </div>
      </div>
    </van-popup>
    <!-- 交易确认表单合约 -->
    <van-popup v-model="showTradeConfirmInfo" position="bottom" closeable>
      <div class="tradeConfirmInfo">
        <div class="tit">{{ $t('trade').Orderconfirmation }}</div>
        <div class="pro">
          <!-- 开多开空 -->
          <div class="p1" :class="buyDirection == 0 ? 'greenbg' : 'redbg'">{{ buyDirection == 0 ? $t('trade').Kato :
            $t('trade').Openempty }}</div>
          <div class="p2">{{ Lever }}X</div>
          <div class="p3">{{ proInfo.name }}</div>
          <div class="p4">{{ TradeType == 0 ? $t('trade').Limit : $t('trade').Present }}</div>
        </div>
        <!-- 市价限价 -->
        <div class="item">{{ $t('trade').Averageopeningprice }}<span>{{ TradeType == 0 ? LimitPrice :
          $t('trade').Marketprice }}</span></div>
        <div class="item">{{ $t('trade').Openingquantity }}<span>{{ Num }}</span></div>
        <div class="item" v-if="StopSurplusPrice">{{ $t('trade').stopSurplusPrice }}<span>{{ StopSurplusPrice }}</span>
        </div>
        <div class="item" v-if="StopLossPrice">{{ $t('trade').Stoplossprice }}<span>{{ StopLossPrice }}</span></div>
        <div class="item">{{ $t('trade').Margin }}<span>{{ Margin }} {{ currency }}</span></div>
        <van-button block :loading="btnloading" @click="handleSub">{{ $t('public').confirm }}</van-button>
      </div>
    </van-popup>
    <!-- 交易确认表单现货 -->
    <van-popup v-model="showTradeConfirmInfo_coin" position="bottom" closeable>
      <div class="tradeConfirmInfo">
        <div class="tit">{{ $t('trade').Orderconfirmation }}</div>
        <div class="pro">
          <div class="p1" :class="buyDirection == 0 ? 'greenbg' : 'redbg'">{{ buyDirection == 0 ? $t('trade').buyBtn :
            $t('trade').sellBtn }}</div>
          <div class="p3">{{ proInfo.name }}</div>
          <div class="p4">{{ TradeType == 0 ? $t('trade').Limit : $t('trade').Present }}</div>
        </div>
        <!-- 市价限价 -->
        <div class="item">{{ $t('trade').Averageprice }}<span>{{ TradeType == 0 ? LimitPrice :
          $t('trade').Marketprice }}</span></div>
        <div class="item">{{ $t('trade').num }}<span>{{ Num }}</span></div>
        <div class="item">{{ $t('trade').totalAmount }}<span>{{ Margin }} USDT</span></div>
        <van-button block :loading="btnloading" @click="handleSub_coin">{{ $t('public').confirm }}</van-button>
      </div>
    </van-popup>
    <!-- 交易确认表单 秒合约 -->
    <van-popup v-model="showTradeConfirmInfo_sec" position="bottom" closeable>
      <div class="tradeConfirmInfo_sec">
        <div class="tit">{{ $t('trade').Orderconfirmation }}</div>
        <div class="secss">{{secondYieldInfo.second}}s</div>
        <div class="pro">
          <div class="p1" :class="buyDirection == 0 ? 'greenbg' : 'redbg'">{{ buyDirection == 0 ? $t('trade').buyUp :
            $t('trade').buyDown }}</div>
          <div class="p3">{{ proInfo.name }}</div>
        </div>
        <!-- 市价 -->
        <div class="item">{{ $t('trade').limitMsg }}<span>{{  proInfo.newPrice }}</span></div>
        <div class="item">{{ $t('trade').totalAmount }}<span>{{ Num }}</span></div>
        <div class="item">{{ $t('trade').incomeRates }}<span>{{ secondYieldInfo.yield }}%</span></div>
        <van-button block :loading="btnloading" @click="handleSub_sec">{{ $t('public').confirm }}</van-button>
      </div>
    </van-popup>
    <!-- 交易结果表单 秒合约 -->
    <van-popup v-model="showSecondOrderInfo" position="bottom" closeable @close="closeSecondOrder">
      <div class="tradeConfirmInfo_sec">
        <div class="tit">{{ $t('trade').buySuccessTips }}</div>
        <div class="secss" v-if="!secondOrderInfo.profitAmount">{{secondOrderInfo.second}}s</div>
        <div class="secss" v-if="secondOrderInfo.profitAmount" :class="secondOrderInfo.profitAmount > 0 ? 'green' : 'red'">{{secondOrderInfo.profitAmount}} USDT</div>
        <div class="pro">
          <div class="p1" :class="secondOrderInfo.buyDirection == 0 ? 'greenbg' : 'redbg'">{{ secondOrderInfo.buyDirection == 0 ? $t('trade').buyUp :
            $t('trade').buyDown }}</div>
          <div class="p3">{{ secondOrderInfo.name }}</div>
        </div>
        <!-- 市价 -->
        <div class="item">{{ $t('trade').limitMsg }}<span>{{  secondOrderInfo.price }}</span></div>
        <div class="item">{{ $t('trade').totalAmount }}<span>{{ secondOrderInfo.amount }}</span></div>
        <div class="item">{{ $t('trade').incomeRates }}<span>{{ secondOrderInfo.yield }}%</span></div>
        <!-- <div class="item" v-if="secondOrderInfo.profitAmount">{{ $t('position').profitloss }}<span :class="secondOrderInfo.profitAmount > 0 ? 'green' : 'red'">{{ secondOrderInfo.profitAmount }}</span></div> -->
        <div class="item" v-if="secondOrderInfo.changeRate">{{ $t('position').changeRate }}<span>{{ secondOrderInfo.changeRate }}</span></div>
      </div>
    </van-popup>
    <TabBar active="Trade" />
  </div>
</template>

<script>
import userApi from '@/api/user'
import productApi from '@/api/product'
import systemApi from '@/api/system'
import orderApi from '@/api/order'
import PublicHeader from '@/components/publicHeader'
import TabBar from '@/components/tabBar'
import { webSocket } from "@/mixins/webSocket.js";
import { EventBus } from '@/utils/event-bus'
import { Token } from '@/utils/mm'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  mixins: [webSocket],
  components: {
    TabBar,
    PublicHeader,
    VueSlider,
  },
  data() {
    return {
      isEmpty: false,
      dragging: false,
      skeletonLoading: true,
      btnloading: false,
      baseUrl: window.baseURL,
      CanNum: 0,
      sellOrders: [],
      buyOrders: [],
      BusinessTypeIndex: 1,//交易业务类型
      buyDirection: 0,
      TradeType: '1',
      showPopover_tradeType: false,//交易类型
      actions_tradeType: [
        { text: this.$t('trade').Present, val: '1' },
        { text: this.$t('trade').Limit, val: '0' }
      ],
      Lever: 10,//杠杆倍数
      showPopover_Lever: false,
      //杠杆选择
      actions_Lever: [],
      Num: null,//数量
      LimitPrice: null,//限价
      marketPrice: null,//市价
      Margin: 0.00,//保证金
      activePrecent: 0,//余额百分比
      selectPrecentArr: [25, 50, 75, 100],
      isSetStop: false,
      StopSurplusPrice: null,//止盈价格
      StopLossPrice: null,//止损价格
      showTradeConfirmInfo: false,//交易确认表单合约
      showTradeConfirmInfo_coin: false,//交易确认表单现货
      showProList: false,
      searchValue: '',
      //行情分类
      activeMarket: 1,
      tabsMarket: [{
        name: this.$t('market').market,
        value: 1
      }, {
        name: this.$t('market').optional,
        value: 0
      },],
      //产品业务
      activeBusiness: 1,
      tabsBusiness: [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      // {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // }, 
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }],
      //产品类型
      activeType: '',
      tabsType: [{
        name: this.$t('public').All,
        value: ""
      }],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      pList: [],
      showAddSelect: false,
      productId: '',
      tabActive: 0,
      proInfo: {
      },
      //持仓类型
      activeOrder: 2,
      tabsOrder: [{
        name: this.$t('position').Position,
        value: 1
      }, {
        name: this.$t('position').commission,
        value: 2
      }],
      order_isRun: false,
      order_loading: false,
      order_finished: false,
      order_parms: {
        pageNum: 1,
        pageSize: 10000,
      },
      oList: [],
      AssetBalance: 0,
      userInfo: {},
      timer: null,
      currency: 'USDT',//币种
      secondYieldList: [],//秒合约收益率列表
      secondYieldInfo: {},//秒合约收益率信息
      showTradeConfirmInfo_sec: false,//交易确认表单秒合约
      secondOrderInfo: {},//秒合约订单信息
      showSecondOrderInfo: false,//交易确认表单秒合约
      timerSec: null,//秒合约订单查询定时器
    }
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    if (this.$route.query.id) {
      this.productId = this.$route.query.id
      this.getProductInfo()
    }
    else
      this.getDefaultProductId()
    this.getConfig()
    this.getMemberInfo()
    this.timer = setInterval(() => {
      this.getProductDealList();
      this.getAssetBalance()
      // this.getOrderList();
    }, 3000);
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
    clearInterval(this.timer);
  },
  methods: {
    onDragStart() {
      this.dragging = true
    },
    onDragEnd() {
      this.dragging = false
    },
    // 获取用户信息
    async getMemberInfo() {
      if (!Token.get()) return
      const res = await userApi.getMemberInfo()
      this.userInfo = res.user
    },
    // 获取资产余额
    async getAssetBalance() {
      if (!Token.get()) return
      this.currency = this.BusinessTypeIndex == 2 ? 'USD' : 'USDT'
      if (this.BusinessTypeIndex == 3 && this.buyDirection == 1)
        this.currency = this.proInfo.currency
      // this.AssetBalance = 0
      var assetType = this.BusinessTypeIndex;
      if (this.BusinessTypeIndex == 4) assetType = 1
      const res = await userApi.getAssetBalance({ assetType: assetType, currency: this.currency })
      this.AssetBalance = res.assetWallet.amount
      this.calCanNum()
    },
    //去充值
    toRecharge() {
      if (this.BusinessTypeIndex == 2)
        this.$goRecharge('Recharge')
      else
        this.$goRecharge('RechargeCurrency')
    },
    //切换交易产品业务
    changeBusinessTypeIndex(val) {
      this.BusinessTypeIndex = val
      this.activeBusiness = val
      if (this.BusinessTypeIndex == 3)
        this.activeOrder = null
      else this.activeOrder = 2
      this.clearFrom()
      this.getDefaultProductId()
    },
    // 查询默认产品id
    async getDefaultProductId() {
      const res = await productApi.getDefaultProductId({ productBusiness: this.BusinessTypeIndex })
      this.productId = res.data
      this.getProductInfo()
    },
    // 查询产品成交列表
    async getProductDealList() {
      const res = await productApi.getProductDealList({ productId: this.productId })
      this.skeletonLoading = false
      this.sellOrders = res.data.sellOrders
      this.buyOrders = res.data.buyOrders
    },
    // 动态计算成交量宽度
    calculateBarWidth(quantity) {
      const maxQuantity = Math.max(...this.buyOrders.map(item => item.vol2)); // 最大值
      var result = quantity / maxQuantity
      result = result > 1 ? 1 : result
      return result * 100 + '%';
    },
    // 获取客户端配置 配置支持产品类型
    async getConfig() {
      this.tabsType = [{
        name: this.$t('public').All,
        value: ""
      }]
      const res = await systemApi.getConfig()
      var productType = res.productType.split(',')
      productType.forEach((sItem) => {
        switch (sItem) {
          case "1":
            this.tabsType.push({
              name: this.$t('public').DigitalCurrency,
              value: "1"
            })
            break;
          case "2":
            this.tabsType.push({
              name: this.$t('public').foreignExchange,
              value: "2"
            })
            break;
          case "3":
            this.tabsType.push({
              name: this.$t('public').futures,
              value: "3"
            })
            break;
          case "4":
            this.tabsType.push({
              name: this.$t('public').stockIndex,
              value: "4"
            })
            break;
          case "5":
            this.tabsType.push({
              name: this.$t('public').stock,
              value: "5"
            })
            break;
        }
      })
      //杠杆
      var levels = res.systemSetting.levels.split(',')
      this.Lever = levels[0]
      levels.forEach((sItem) => {
        this.actions_Lever.push({
          text: sItem + 'x',
          val: sItem
        })
      })
    },
    // 展示产品列表
    onShowProduct() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.searchValue = ''
      this.onSearch()
      this.showProList = true
    },
    //搜索
    onSearch() {
      this.pList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.onGetProductList()
    },
    //获取产品行情/自选列表事件
    onGetProductList() {
      if (this.activeMarket == 0) this.getOptionalProductList()
      if (this.activeMarket == 1) this.getProductList()
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      this.onSearch()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      if (this.activeBusiness != 2 && this.activeBusiness != 4)
        this.activeType = ''
      if (this.activeBusiness == 3)
        this.activeOrder = null
      else this.activeOrder = 2
      this.onSearch()
    },
    //切换产品类型
    changeTypeTab(val) {
      this.activeType = val
      this.onSearch()
    },
    // 选择产品
    selectProduct(productId) {
      this.showProList = false
      this.productId = productId
      this.clearFrom()
      this.getProductInfo()
    },
    // 获取自选产品列表
    async getOptionalProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getOptionalProductList(this.parms)
      this.pList.push(...res.rows);
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 获取产品列表
    async getProductList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.productType = this.activeType
      this.parms.name = this.searchValue
      const res = await productApi.getProductList(this.parms)
      this.pList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.pList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //产品详情
    async getProductInfo() {
      const res = await productApi.getProductInfo({ productId: this.productId })
      this.proInfo = res.data
      this.BusinessTypeIndex = this.proInfo.productBusiness
      if (this.BusinessTypeIndex == 4)
        this.getSecondYield()
      this.webSocketInit(() => {
        this.websocketInfoGet()
      })
      if (this.BusinessTypeIndex == 4) this.getSecondOrderList()
      else this.getOrderList()
      this.getAssetBalance()
      this.getProductDealList()
    },
    //合约产品期限
    async getSecondYield() {
      const res = await productApi.getSecondYield({ productType: this.proInfo.productType })
      this.secondYieldList = res.data
      this.secondYieldInfo = this.secondYieldList[0]
    },
    //推送单品
    websocketInfoGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: [that.proInfo.symbol]
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        //产品详情
        let quotesInfo = reslult.find(item => item.Symbol == that.proInfo.symbol);
        if (quotesInfo) {
          that.proInfo.high = quotesInfo.High
          that.proInfo.low = quotesInfo.Low
          that.proInfo.newPrice = quotesInfo.NewPrice
          that.proInfo.volume = quotesInfo.Volume
          that.proInfo.priceChangeRatio = quotesInfo.PriceChangeRatio
          that.marketPrice = quotesInfo.NewPrice
          //订单盈亏
          if (that.oList.length > 0 && (that.BusinessTypeIndex == 1 || that.BusinessTypeIndex == 2)) {
            // 产品列表
            that.oList.forEach((sItem) => {
              // 盈亏=持仓订单(产品价格-购买单价)【绝对值】x数量
              var profit = (Math.abs(sItem.price - quotesInfo.NewPrice) * sItem.quantity)
              //买涨 价格下跌
              if (sItem.buyDirection == '0' && sItem.price > quotesInfo.NewPrice)
                profit = -profit
              //买跌 价格上涨
              if (sItem.buyDirection == '1' && sItem.price < quotesInfo.NewPrice)
                profit = -profit
              //盈亏要减去手续费
              profit = profit - sItem.changeRate
              sItem.profitAmount = profit.toFixed(4).replace(/\.?0+$/, '')
            })
          }
        }
      })
    },
    //推送列表
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
    //选择交易方向买入卖出
    onBuyDirection(val) {
      this.buyDirection = val
      this.clearFrom()
      this.getAssetBalance()
    },
    //选择百分比滑块
    handlePrecent(val) {
      if (!this.dragging) {
        // 不是拖动时（即点击），自动调整到最近的 marks 值
        const snapPoints = [0, 25, 50, 75, 100]
        const closest = snapPoints.reduce((a, b) =>
          Math.abs(b - val) < Math.abs(a - val) ? b : a
        )
        this.activePrecent = closest
      }
      var price = this.proInfo.newPrice
      // 限价
      if (this.TradeType == '0')
        price = this.LimitPrice
      if (this.activePrecent === 100) {
        if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2) {
          this.Num = ((this.AssetBalance / price) * this.Lever).toFixed(6).replace(/\.?0+$/, '')
        }
        //现货
        if (this.BusinessTypeIndex == 3)
          this.Num = (this.AssetBalance / price).toFixed(6).replace(/\.?0+$/, '')
        //秒合约
        if (this.BusinessTypeIndex == 4)
          this.Num = this.AssetBalance
        this.Margin = this.AssetBalance
        // 现货卖出 价格=数量
        if (this.BusinessTypeIndex == 3 && this.buyDirection == 1) {
          this.Num = this.AssetBalance
          this.Margin = (price * this.Num).toFixed(6).replace(/\.?0+$/, '')
        }
      } else {
        // 现货卖出 价格=数量
        if (this.BusinessTypeIndex == 3 && this.buyDirection == 1)
          price = 1
        if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2)
          this.Num = (((this.activePrecent / 100) * this.AssetBalance) / price * this.Lever).toFixed(6).replace(/\.?0+$/, '')
        //现货
        if (this.BusinessTypeIndex == 3)
          this.Num = (((this.activePrecent / 100) * this.AssetBalance) / price).toFixed(6).replace(/\.?0+$/, '')
        //秒合约
        if (this.BusinessTypeIndex == 4)
          this.Num = (((this.activePrecent / 100) * this.AssetBalance)).toFixed(6).replace(/\.?0+$/, '')
        this.calMarginAmount()
      }
    },
    //输入数量事件
    onInputNum() {
      if (this.Num) {
        var price = this.proInfo.newPrice
        // 限价
        if (this.TradeType == '0')
          price = this.LimitPrice
        // 现货卖出 价格=数量
        if (this.BusinessTypeIndex == 3 && this.buyDirection == 1)
          price = 1
        if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2)
          this.activePrecent = Number(this.Num * price / this.Lever / this.AssetBalance * 100)
        //现货
        if (this.BusinessTypeIndex == 3)
          this.activePrecent = Number(this.Num * price / this.AssetBalance * 100)
        //秒合约
        if (this.BusinessTypeIndex == 4)
          this.activePrecent = Number(this.Num / this.AssetBalance * 100)
        if (this.activePrecent > 100) this.activePrecent = 100
      } else this.activePrecent = 0
      this.calMarginAmount()
    },
    //计算可购买数量
    calCanNum() {
      if (!Token.get()) return
      var price = this.proInfo.newPrice
      //限价
      if (this.TradeType == '0')
        price = this.LimitPrice
      if (this.BusinessTypeIndex != 3)
        this.CanNum = (this.AssetBalance / price * this.Lever).toFixed(6).replace(/\.?0+$/, '')
      else
        //现货 金额=价格*数量
        this.CanNum = (this.AssetBalance / price).toFixed(6).replace(/\.?0+$/, '')
    },
    // 选择类型
    async onSelect_TradeType(action) {
      this.TradeType = action.val
      this.LimitPrice = this.proInfo.newPrice
      this.calMarginAmount()
    },
    // 选择杠杆倍数
    async onSelect_Lever(action) {
      this.Lever = action.val
      this.calMarginAmount()
    },
    //计算保证金总金额
    calMarginAmount() {
      this.calCanNum()
      var price = this.proInfo.newPrice
      //限价
      if (this.TradeType == '0')
        price = this.LimitPrice
      if (this.Num) {
        if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2)
          //保证金=价格*数量/杠杆
          this.Margin = (price * this.Num / this.Lever).toFixed(6).replace(/\.?0+$/, '')
        else
          //现货 秒合约 金额=价格*数量
          this.Margin = (price * this.Num).toFixed(6).replace(/\.?0+$/, '')
      }
      //余额判断
      if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2) {
        //合约
        if (this.Margin > this.AssetBalance)
          this.$toast(this.$t('public').BalanceNot)
      }
      if (this.BusinessTypeIndex == 3) {
        //现货买入
        if (this.buyDirection == 0)
          if (this.Margin > this.AssetBalance)
            this.$toast(this.$t('public').BalanceNot)
        //现货卖出
        if (this.buyDirection == 1)
          if (this.Num > this.AssetBalance)
            this.$toast(this.$t('public').BalanceNot)
      }
      if (this.BusinessTypeIndex == 4) {
        //秒合约
        if (this.Num > this.AssetBalance)
          this.$toast(this.$t('public').BalanceNot)
      }
    },
    // 校验表单
    checkForm() {
      //没有行情 不让提交
      if (!this.marketPrice) {
        return false
      }
      // 数量
      if (!this.Num || this.Num <= 0) {
        this.$toast(this.$t('trade').putNummsg)
        return false
      }
      // 秒合约 最少金额
      if (this.BusinessTypeIndex == 4 && this.Num < this.secondYieldInfo.minNum) {
        this.$toast(this.$t('trade').minbuyNums + this.secondYieldInfo.minNum + ' USDT')
        return false
      }
      // 限价
      if (this.TradeType == "0") {
        if (!this.LimitPrice) {
          this.$toast(this.$t('trade').putLimitPriceMsg)
          return false
        }
        //买涨只能输入比市场价低的价格
        if (this.buyDirection == '0') {
          if (this.BusinessTypeIndex != 3) {
            //合约
            if (this.LimitPrice > this.proInfo.newPrice) {
              this.$toast(this.$t('trade').buyLimtMsg)
              return false
            }
          }
          else {
            //现货
            if (this.LimitPrice > this.proInfo.newPrice) {
              this.$toast(this.$t('trade').buyLimtMsg2)
              return false
            }
          }
        }
        //买跌只能输入比市场价高的价格
        if (this.buyDirection == '1') {
          if (this.BusinessTypeIndex != 3) {
            //合约
            if (this.LimitPrice < this.proInfo.newPrice) {
              this.$toast(this.$t('trade').sellLimtMsg)
              return false
            }
          }
          else {
            //现货
            if (this.LimitPrice < this.proInfo.newPrice) {
              this.$toast(this.$t('trade').sellLimtMsg2)
              return false
            }
          }
        }
      }
      //余额判断
      if (this.BusinessTypeIndex == 1 || this.BusinessTypeIndex == 2) {
        //合约
        if (this.Margin > this.AssetBalance) {
          this.$toast(this.$t('public').BalanceNot)
          return false
        }
      }
      if (this.BusinessTypeIndex == 3) {
        //现货买入
        if (this.buyDirection == 0)
          if (this.Margin > this.AssetBalance) {
            this.$toast(this.$t('public').BalanceNot)
            return false
          }
        //现货卖出
        if (this.buyDirection == 1)
          if (this.Num > this.AssetBalance) {
            this.$toast(this.$t('public').BalanceNot)
            return false
          }
      }
      if (this.BusinessTypeIndex == 4) {
        //秒合约
        if (this.Num > this.AssetBalance) {
          this.$toast(this.$t('public').BalanceNot)
          return false
        }
      }
      // 实名认证校验
      if (!this.$store.state.isSim && this.userInfo.authenticationStatus != '2' && this.userInfo.authenticationStatus != '3' && this.userInfo.authenticationStatus != '4') {
        this.$dialog.confirm({
          title: this.$t('trade').authTips,
          confirmButtonText: this.$t('public').confirm,
          confirmButtonColor: 'var(--text_color)',
          cancelButtonText: this.$t('public').cancel,
          cancelButtonColor: 'var(--ntext_color)',
        })
          .then(() => {
            this.$router.push({ name: 'Auth' })
          })
        return false
      }
      return true
    },
    //清空表单
    clearFrom() {
      this.Num = ''
      this.Margin = 0
      this.TradeType = 1
      this.LimitPrice = ''
      this.activePrecent = 0
      this.isSetStop = false
      this.StopSurplusPrice = ''
      this.StopLossPrice = ''
    },
    //展示交易确认表单合约
    showOrderInfo(val) {
      this.buyDirection = val
      if (!this.checkForm()) return
      this.showTradeConfirmInfo = true
    },
    //提交合约
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        productId: this.productId,
        currency: this.currency,
        buyDirection: this.buyDirection,
        tradeType: this.TradeType,
        limitPrice: this.LimitPrice,
        marketPrice: this.marketPrice,
        quantity: this.Num,
        lever: this.Lever,
        stopSurplusPrice: this.StopSurplusPrice,
        stopLossPrice: this.StopLossPrice,
        isAllPrecent: this.activePrecent == 100,
      }
      this.btnloading = true
      await orderApi.createOrder(form)
      this.btnloading = false
      this.$toast(this.$t('trade').orderSuccess)
      this.clearFrom()
      this.showTradeConfirmInfo = false
      this.getAssetBalance()
      this.getOrderList()
    },
    //展示交易确认表单现货
    showOrderInfo_coin(val) {
      this.buyDirection = val
      if (!this.checkForm()) return
      this.showTradeConfirmInfo_coin = true
    },
    //提交现货
    async handleSub_coin() {
      if (!this.checkForm()) return
      const form = {
        productId: this.productId,
        currency: this.currency,
        buyDirection: this.buyDirection,
        tradeType: this.TradeType,
        limitPrice: this.LimitPrice,
        marketPrice: this.marketPrice,
        quantity: this.Num,
        isAllPrecent: this.activePrecent == 100,
      }
      this.btnloading = true
      await orderApi.createCoinOrder(form)
      this.btnloading = false
      this.$toast(this.$t('trade').orderSuccess)
      this.clearFrom()
      this.showTradeConfirmInfo_coin = false
      this.getAssetBalance()
      this.getOrderList()
    },
    //展示交易确认表单秒合约
    showOrderInfo_sec(val) {
      this.buyDirection = val
      if (!this.checkForm()) return
      this.showTradeConfirmInfo_sec = true
    },
    //提交秒合约
    async handleSub_sec() {
      if (!this.checkForm()) return
      const form = {
        productId: this.productId,
        productSecondSetId: this.secondYieldInfo.productSecondSetId,
        buyDirection: this.buyDirection,
        marketPrice: this.marketPrice,
        quantity: this.Num,
        isAllPrecent: this.activePrecent == 100,
      }
      this.btnloading = true
      var res = await orderApi.createSecondOrder(form)
      this.btnloading = false
      this.$toast(this.$t('trade').orderSuccess)
      this.clearFrom()
      this.secondOrderInfo = res.data
      this.showTradeConfirmInfo_sec = false
      this.getAssetBalance()
      this.getSecondOrderList()
      this.showSecondOrderInfo = true
      this.timerSec = setInterval(() => {
        if (this.secondOrderInfo.second > 0) {
          this.secondOrderInfo.second--
        } else {
          clearInterval(this.timerSec)
          this.timerSec = null
          this.getSecondOrderInfo()
        }
      }, 1000)
    },
    // 查询秒合约订单列表
    async getSecondOrderList() {
      if (!Token.get()) return
      this.order_parms.productId = this.productId
      this.order_parms.status = null
      const res = await orderApi.getSecondOrderList(this.order_parms)
      this.oList = res.rows;
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
    },
    //秒合约详情
    async getSecondOrderInfo() {
      var res = await orderApi.getSecondOrderInfo({ orderSecondId: this.secondOrderInfo.orderSecondId })
      this.secondOrderInfo = res.data
    },
    //关闭秒合约详情
    closeSecondOrder() {
      clearInterval(this.timerSec)
      this.timerSec = null
      this.getSecondOrderList()
    },
    // 切换持仓类型
    changeOrderTab(val) {
      this.activeOrder = val
      this.getOrderList()
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.order_parms.pageNum = 1
      this.order_finished = false;
      this.getOrderList()
    },
    // 轮训刷新当前页订单列表
    async getNowPageOrderList() {
      if (!Token.get()) return
      if (this.order_isRun) return
      console.log(this.order_parms.pageNum)
      const currentPage = this.order_parms.pageNum > 1 ? this.order_parms.pageNum - 1 : 1;
      const startIndex = (currentPage - 1) * this.order_parms.pageSize;
      const parms = {
        ...this.order_parms,
        productId: this.productId,
        status: this.activeOrder,
        pageNum: currentPage
      }
      const res = await orderApi.getOrderList(parms)
      const newRows = res.rows;
      // 用 Map 快速查找当前页已有订单对应索引
      const idMap = new Map();
      for (let i = startIndex; i < Math.min(this.oList.length, startIndex + this.order_parms.pageSize); i++) {
        const item = this.oList[i];
        if (item && item.orderId) idMap.set(item.orderId, i);
      }
      // 遍历新数据，根据 id 更新已有对象
      newRows.forEach(item => {
        if (idMap.has(item.orderId)) {
          // 更新已有对象字段
          Object.assign(this.oList[idMap.get(item.orderId)], item);
        } else {
          // 新增订单直接替换对应位置（保证页大小不变）
          const insertIndex = startIndex + newRows.indexOf(item);
          this.oList[insertIndex] = item;
        }
      });
      // 删除当前页里已经不存在的订单
      const newIds = new Set(newRows.map(i => i.orderId));
      for (let i = Math.min(this.oList.length - 1, startIndex + this.order_parms.pageSize - 1); i >= startIndex; i--) {
        if (!newIds.has(this.oList[i]?.orderId)) {
          this.oList.splice(i, 1);
        }
      }
    },
    // 获取订单列表
    async getOrderList() {
      if (!Token.get()) return
      this.order_parms.productId = this.productId
      if (this.BusinessTypeIndex == 3)
        this.activeOrder = null
      this.order_parms.status = this.activeOrder
      const res = await orderApi.getOrderList(this.order_parms)
      this.oList = res.rows;
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding-bottom: calc(75px + var(--bottom-toolbar-offset, 0px));

  .top {
    display: flex;
    align-items: center;
    padding: 15px 15px 5px 15px;
    font-weight: bold;
    font-size: 17px;
    color: var(--ntext_color);
    background: var(--background_color);

    span {
      margin-right: 15px;
    }

    .active {
      color: var(--text_color);
    }
  }

  .proNum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background: var(--background_color);

    .left {
      display: flex;
      align-items: center;

      .name {
        font-size: 17px;
        font-weight: bold;
        color: var(--text_color);
      }

      .ric {
        transform: rotate(90deg);
        margin: 0 5px;
      }

      .flu {
        font-size: 13px;
      }

      .closetime {
        font-size: 10px;
        color: var(--ntext_color);
        margin-left: 10px;
      }
    }

    .svgs {
      width: 20px;
      height: 20px;
      color: var(--text_color);
    }
  }

  .conInfo {
    padding: 10px 15px 15px 15px;
    display: flex;
    justify-content: space-between;

    .tradeInfo {
      width: 50%;

      .ric {
        transform: rotate(90deg);
      }

      .level {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid var(--info_color);
        border-radius: 10px;
        height: 30px;
        padding: 0 10px;
        font-size: 14px;
        color: var(--text_color);
      }

      .tabs {
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--info_color);
        border-radius: 10px;
        height: 30px;
        font-size: 14px;
        color: var(--text_color);

        .left {
          width: 50%;
          text-align: center;
        }

        .right {
          width: 50%;
          text-align: center;
        }

        .active {
          background: var(--background_color);
          margin: 0 2px;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
        }
      }

      .trdType {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid var(--info_color);
        border-radius: 10px;
        height: 30px;
        padding: 0 10px;
        font-size: 14px;
        color: var(--text_color);
      }

      .lable {
        margin-top: 10px;
        font-size: 14px;
        color: var(--ntext_color);
        background: var(--info_color);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
      }

      .sliderPrecent {
        margin: 15px 5px 30px 5px;

        .slable {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: var(--ntext_color);
        }
      }

      .lable2 {
        margin-top: 15px;
        display: flex;
        align-items: center;
        font-size: 13px;
        color: var(--text_color);

        span {
          margin-left: 5px;
        }
      }

      .bal {
        margin: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);

          .svgs {
            width: 13px;
            height: 13px;
            color: var(--text_color);
          }
        }
      }

      .txt {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }

      .buyBtn {
        margin: 5px 0 10px 0;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2dbd84;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      .sellBtn {
        margin-top: 5px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5465d;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      ::v-deep .van-field__value {
        overflow: visible;
        display: grid;
      }

      ::v-deep .van-field__label {
        margin-right: 5px;
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        width: auto;
        font-size: 12px;
        font-weight: normal;
      }

      ::v-deep .van-field__control {
        color: var(--text_color);
      }

      ::v-deep .van-field__control::-webkit-input-placeholder {
        color: var(--ntext_color);
      }

      ::v-deep .van-cell {
        background: var(--background_color);
        border: 1px solid var(--info_color);
        border-radius: 10px;
        padding: 0 10px;
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        height: 40px;
      }
    }

    .tradeInfobb {
      width: 50%;

      .ric {
        transform: rotate(90deg);
      }

      .tabs {
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--info_color);
        border-radius: 10px;
        height: 30px;
        font-size: 14px;
        color: var(--text_color);

        .left {
          width: 50%;
          text-align: center;
        }

        .right {
          width: 50%;
          text-align: center;
        }

        .active {
          background: #2dbd84;
          margin: 0 2px;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          color: #fff;
        }

        .active1 {
          background: #f5465d;
          margin: 0 2px;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
          color: #fff;
        }
      }

      .trdType {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid var(--info_color);
        border-radius: 10px;
        height: 30px;
        padding: 0 10px;
        font-size: 14px;
        color: var(--text_color);
      }

      .lable {
        margin-top: 10px;
        font-size: 14px;
        color: var(--ntext_color);
        background: var(--info_color);
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
      }

      .sliderPrecent {
        margin: 15px 5px 30px 5px;

        .slable {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: var(--ntext_color);
        }
      }

      .lable2 {
        margin-top: 15px;
        display: flex;
        align-items: center;
        font-size: 13px;
        color: var(--text_color);

        span {
          margin-left: 5px;
        }
      }

      .bal {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);

          .svgs {
            width: 13px;
            height: 13px;
            color: var(--text_color);
          }
        }
      }

      .txt {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }

      .buyBtn {
        margin-top: 20px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2dbd84;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      .sellBtn {
        margin-top: 20px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5465d;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      ::v-deep .van-field__value {
        overflow: visible;
        display: grid;
      }

      ::v-deep .van-field__label {
        margin-right: 5px;
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        width: auto;
        font-size: 12px;
        font-weight: normal;
      }

      ::v-deep .van-field__control {
        color: var(--text_color);
      }

      ::v-deep .van-field__control::-webkit-input-placeholder {
        color: var(--ntext_color);
      }

      ::v-deep .van-cell {
        background: var(--background_color);
        border: 1px solid var(--info_color);
        border-radius: 10px;
        padding: 0 10px;
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        height: 40px;
      }
    }

    .tradeInfoSec {
      width: 50%;

      .ric {
        transform: rotate(90deg);
      }

      .lable {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
          margin-left: 5px;
        }
      }
      .secItems {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 10px;
        .item {
          width: 48%;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 13px;
          background: var(--info_color);
          color: var(--ntext_color);
          border-radius: 10px;
          padding: 10px;
          margin-top: 7px;
          .txtss {
            margin-top: 10px;
          }
        }
        .active {
          background: var(--text_color);
          color: var(--background_color);
        }
      }

      .sliderPrecent {
        margin: 10px 5px 25px 5px;

        .slable {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: var(--ntext_color);
        }
      }

      .bal {
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);

          .svgs {
            width: 13px;
            height: 13px;
            color: var(--text_color);
          }
        }
      }

      .txt {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }

      .buyBtn {
        margin: 5px 0 10px 0;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #2dbd84;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      .sellBtn {
        margin-top: 5px;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5465d;
        color: #fff;
        font-size: 13px;
        border-radius: 18px;
      }

      ::v-deep .van-field__value {
        overflow: visible;
        display: grid;
      }

      ::v-deep .van-field__label {
        margin-right: 5px;
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        width: auto;
        font-size: 12px;
        font-weight: normal;
      }

      ::v-deep .van-field__control {
        color: var(--text_color);
      }

      ::v-deep .van-field__control::-webkit-input-placeholder {
        color: var(--ntext_color);
      }

      ::v-deep .van-cell {
        background: var(--background_color);
        border: 1px solid var(--info_color);
        border-radius: 10px;
        padding: 0 10px;
        margin-top: 10px;
        font-size: 16px;
        font-weight: bold;
        height: 40px;
      }
    }

    .orderBook {
      width: 50%;
      margin-left: 15px;

      .tit {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: var(--ntext_color);
        margin-bottom: 15px;
      }

      .orderRow {
        padding: 5px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        font-size: 13px;

        .quantity {
          color: var(--text_color);
        }

        .sellbar {
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background-color: rgba(255, 0, 0, 0.1);
        }

        .buybar {
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background-color: rgba(0, 255, 0, 0.1);
        }
      }

      .newprice {
        font-weight: bold;
        font-size: 17px;
        margin: 12px 0;
      }
    }
  }

  .lines {
    height: 7px;
    background: var(--info_color);
  }

  .positionTitle {
    padding: 0 15px;
    font-size: 14px;
    font-weight: bold;
    color: var(--ntext_color);
    border-bottom: 1px solid var(--info_color);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .left {
      padding: 12px 0;

      span {
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--text_color);
      }
    }

    .svgs {
      padding: 12px 0;
      width: 18px;
      height: 18px;
      color: var(--text_color);
      margin-left: auto;
    }
  }

  .positionInfo {
    padding: 15px 15px 125px 15px;

    .title {
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        width: 25%;
        text-align: center;
      }

      .direction {
        text-align: left;
      }

      .time {
        text-align: right;
      }
    }

    .item {
      padding: 20px 0;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: var(--text_color);

      span {
        width: 25%;
        text-align: center;
        overflow-wrap: break-word;
      }

      .direction {
        text-align: left;
      }

      .time {
        text-align: right;
        font-size: 12px;
        color: var(--ntext_color);
      }
    }

    .empty {
      margin-top: 50px;
      text-align: center;

      .esvgs {
        width: 50px;
        height: 50px;
      }

      .txt {
        margin-top: 30px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .positionInfo_coin {
    padding: 15px 15px 125px 15px;

    .title {
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: var(--ntext_color);

      span {
        width: 16%;
        text-align: center;
      }

      .direction {
        text-align: left;
      }

      .time {
        width: 19%;
        text-align: center;
      }

      .stau {
        width: 16%;
        text-align: right;
      }
    }

    .item {
      padding: 20px 0;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: var(--text_color);

      span {
        width: 16%;
        text-align: center;
        word-break: break-all;
        margin-right: 5px;
      }

      .direction {
        text-align: left;
      }

      .time {
        width: 19%;
        text-align: center;
        font-size: 12px;
        color: var(--ntext_color);
      }

      .stau {
        margin-left: 2%;
        text-align: center;
        width: 14%;
        font-size: 10px;
        padding: 5px;
        border-radius: 5px;
        color: #fff;
      }
    }

    .empty {
      margin-top: 50px;
      text-align: center;

      .esvgs {
        width: 50px;
        height: 50px;
      }

      .txt {
        margin-top: 30px;
        font-size: 12px;
        color: var(--text_color);
      }
    }
  }

  .pro_list {
    ::v-deep .van-search__content {
      background-color: var(--info_color);
    }

    ::v-deep .van-cell {
      color: var(--text_color);
    }

    ::v-deep .van-field__control {
      color: var(--text_color);
    }

    background: var(--background_color);
    height: 90vh;

    .serarchInfo {
      width: 70%;
    }

    .topInfo {
      width: 100%;
      background: var(--background_color);
      padding-top: 10px;

      .proTab {
        padding: 12px 15px;
        font-size: 17px;
        font-weight: bold;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);

        span {
          margin-right: 20px;
        }

        .active {
          color: var(--text_color);
        }
      }

      .protypeTab {
        padding: 0 15px;
        font-size: 14px;
        font-weight: bold;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          padding: 12px 0;

          span {
            margin-right: 20px;
          }

          .active {
            color: var(--text_color);
            padding-bottom: 10px;
            border-bottom: 2px solid var(--text_color);
          }
        }

        .svgs {
          width: 18px;
          height: 18px;
          color: var(--text_color);
        }
      }

      .tabs {
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        font-size: 13px;
        padding: 8px 15px;
        border-bottom: 1px solid var(--info_color);

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          margin-right: 10px;
        }

        .active {
          background: var(--info_color);
          border-radius: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 5px 10px;
          color: var(--text_color);
        }
      }

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        padding: 0 15px;
        font-size: 12px;
        height: 50px;

        .name {
          width: 30%;
          text-align: left;
        }

        span {
          width: 20%;
          text-align: right;
        }
      }
    }

    .addSelectBtn {
      margin: 100px 15px 85px 15px;

      .van-button {
        margin-top: 20px;
        background: var(--text_color);
        height: 40px;
        border-radius: 20px;
        border: 0;
        font-size: 15px;
        color: var(--background_color);
      }
    }

    .productInfo {
      padding: 0 15px 15px 15px;
      // height: calc(90vh - 250px);
      overflow-y: scroll;

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        color: var(--text_color);
        font-size: 13px;

        .name {
          font-weight: bold;
          width: 30%;
          text-align: left;
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 10px;
          }
        }

        span {
          width: 20%;
          text-align: right;
        }

        .ratio {
          width: 20%;
          padding: 5px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          border-radius: 5px;
        }

        &:active {
          background: var(--info_color);
        }
      }
    }
  }

  .tradeConfirmInfo {
    padding: 15px;

    .tit {
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      color: var(--text_color);
    }

    .pro {
      margin-top: 30px;
      display: flex;
      align-items: center;

      .p1 {
        padding: 5px;
        border-radius: 5px;
        font-size: 11px;
        color: #fff;
        margin-right: 5px;
      }

      .p2 {
        padding: 5px;
        background: rgba(255, 30, 0, 0.1);
        border-radius: 5px;
        font-size: 11px;
        color: #f5465d;
        margin-right: 5px;
      }

      .p3 {
        font-size: 14px;
        font-weight: bold;
        color: var(--text_color);
        margin-right: 5px;
      }

      .p4 {
        padding: 5px;
        background: var(--info_color);
        border-radius: 5px;
        font-size: 12px;
        color: var(--text_color);
      }
    }

    .item {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }
  }
  .tradeConfirmInfo_sec {
    padding: 15px;

    .tit {
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      color: var(--text_color);
    }

    .secss {
      margin-top: 30px;
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
    }

    .pro {
      margin-top: 30px;
      display: flex;
      align-items: center;

      .p1 {
        padding: 5px;
        border-radius: 5px;
        font-size: 11px;
        color: #fff;
        margin-right: 5px;
      }

      .p2 {
        padding: 5px;
        background: rgba(255, 30, 0, 0.1);
        border-radius: 5px;
        font-size: 11px;
        color: #f5465d;
        margin-right: 5px;
      }

      .p3 {
        font-size: 14px;
        font-weight: bold;
        color: var(--text_color);
        margin-right: 5px;
      }

      .p4 {
        padding: 5px;
        background: var(--info_color);
        border-radius: 5px;
        font-size: 12px;
        color: var(--text_color);
      }
    }

    .item {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }
  }
}

::v-deep .van-dialog {
  background-color: transparent;
}

::v-deep .van-popup--left {
  top: 65px;
  height: calc(100vh - 60px) !important;
  overflow: 'hidden';
  width: 90%;
  transform: translate3d(0, 0, 0);
  border-radius: 0 10px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

::v-deep .van-popover__wrapper {
  display: inline;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: var(--background_color);
}

::v-deep .vue-slider-dot-tooltip-inner-top::after {
  border-top-color: var(--info_color) !important;
}

::v-deep .vue-slider-mark {
  background: var(--background_color);
  width: 10px !important;
  height: 10px !important;
  border: 2px solid var(--info_color);
  border-radius: 50%;
}

::v-deep .vue-slider-mark-active {
  border: 2px solid var(--text_color);
}

::v-deep .vue-slider-mark-label {
  color: var(--ntext_color);
  font-size: 11px;
}
</style>
